module.exports = __webpack_public_path__ + "static/img/wood52.f268b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood52.jpg
// module id = uhAr
// module chunks = 0